export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_PROFILE_INFO_SUCCESS = "UPDATE_PROFILE_INFO_SUCCESS";
export const ADD_STORY_COUNT = "ADD_STORY_COUNT";
export const STORY_METRICS_CHANGE = "STORY_METRICS_CHANGE";
export const SUBTRACT_STORY_COUNT = "SUBTRACT_STORY_COUNT";
// setStoryActivity
export const SET_STORY_ACTIVITY = "SET_STORY_ACTIVITY";

export const RESET_PASSWORD_LINK_SENT = "RESET_PASSWORD_LINK_SENT";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const SET_PASSWORD_SUCCESS = "SET_PASSWORD_SUCCESS";
export const INDUSTRY_CHANGE_SUCCESS = "INDUSTRY_CHANGE_SUCCESS";
export const ENTERPRISE_NAME_CHANGE_SUCCESS = "ENTERPRISE_NAME_CHANGE_SUCCESS";
export const SKIPPED_ORG_SETUP = "SKIPPED_ORG_SETUP";

export const ORG_CHANGE_SUCCESS = "ORG_CHANGE_SUCCESS";
export const ORG_HIER_CHANGE = "ORG_HIER_CHANGE";
export const ORG_REMOVE_EMAIL = "ORG_REMOVE_EMAIL";
export const ORG_REMOVE_SLACK_URL = "ORG_REMOVE_SLACK_URL";
export const ORG_REMOVE_TEAMS_TENANT = "ORG_REMOVE_TEAMS_TENANT";

export const LOGOUT = "LOGOUT";

//Toolkit
export const ADD_TOOL_CHOOSE_CATEGORY_SUCCESS =
  "ADD_TOOL_CHOOSE_CATEGORY_SUCCESS";
export const TOOL_INFO_COMPLETED = "TOOL_INFO_COMPLETED";
export const TOOL_FOCUS_COMPLETED = "TOOL_FOCUS_COMPLETED";
export const TOOL_LOCATION_AND_CONTACT_COMPLETED =
  "TOOL_LOCATION_AND_CONTACT_COMPLETED";
export const TOOL_PRIVACY_SETTINGS_COMPLETED =
  "TOOL_PRIVACY_SETTINGS_COMPLETED";
export const TOOL_GO_BACK_PRESSED = "TOOL_GO_BACK_PRESSED";
export const ADD_TOOL_BACK_TO_EDIT = "TOOL_BACK_TO_EDIT";
export const ADD_TOOL_SUCCESS = "ADD_TOOL_SUCCESS";
export const EDIT_TOOL_SUCCESS = "EDIT_TOOL_SUCCESS";
export const TOOL_LOADED = "TOOL_LOADED";
export const LEAVE_ADD_TOOL = "LEAVE_ADD_TOOL";
export const LEAVE_EDIT_TOOL = "LEAVE_EDIT_TOOL";
export const LEAVE_PREVIEW_TOOL = "LEAVE_PREVIEW_TOOL";

//Analytics
export const ADD_CHART_CHOOSE_CATEGORY_SUCCESS =
  "ADD_CHART_CHOOSE_CATEGORY_SUCCESS";
export const ANALYTICS_CATEGORY_KPI_DATA_FETCHED =
  "ANALYTICS_CATEGORY_KPI_DATA_FETCHED";
export const KPI_AGRREGATE_DATA_FETCHED = "KPI_AGRREGATE_DATA_FETCHED";
export const CHART_DETAILS_COMPLETED = "CHART_DETAILS_COMPLETED";
export const CHART_PRIVACY_SETTINGS_COMPLETED =
  "CHART_PRIVACY_SETTINGS_COMPLETED";
export const CHART_GO_BACK_PRESSED = "CHART_GO_BACK_PRESSED";
export const ADD_CHART_SUCCESS = "ADD_CHART_SUCCESS";
export const EDIT_CHART_SUCCESS = "EDIT_CHART_SUCCESS";
export const CHART_LOADED = "CHART_LOADED";
export const LEAVE_CREATE_CHART = "LEAVE_CREATE_CHART";
export const LEAVE_EDIT_CHART = "LEAVE_EDIT_CHART";

//Office
export const FETCH_OFFICE_SUCCESS = "FETCH_OFFICE_SUCCESS";

//Dani
export const OPEN_DANI = "OPEN_DANI";
export const CLOSE_DANI = "CLOSE_DANI";
export const TRIGGER_NEXT_STEP = "TRIGGER_NEXT_STEP";
export const OPTION_SELECTED = "OPTION_SELECTED";
export const CHART_SELECTED = "CHART_SELECTED";
export const CHART_UNSELECTED = "CHART_UNSELECTED";
export const FETCH_RECOMMENDED_TOOLS = "FETCH_RECOMMENDED_TOOLS";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SEARCH_RESULTS_FETCHED = "SEARCH_RESULTS_FETCHED";
export const MORE_SEARCH_RESULTS_FETCHED = "MORE_SEARCH_RESULTS_FETCHED";
export const TOOLKIT_SELECTED = "TOOLKIT_SELECTED";
export const CLOSE_DANI_HELP_TEXT = "CLOSE_DANI_HELP_TEXT";
export const DRILLDOWN_CHART = "DRILLDOWN_CHART";
export const CLOSE_DRILLDOWN_MODAL = "CLOSE_DRILLDOWN_MODAL";
export const SELECT_KPI_FOR_CHART = "SELECT_KPI_FOR_CHART";
export const MINIMIZE_DANI = "MINIMIZE_DANI";
export const MAXIMIZE_DANI = "MAXIMIZE_DANI";
export const UNSELECT_CHART_WITH_NO_FEEDBACK =
  "UNSELECT_CHART_WITH_NO_FEEDBACK";
export const RECOMMENDED_TOOLKIT_OPTION_SELECTED =
  "RECOMMENDED_TOOLKIT_OPTION_SELECTED";

//Org Chart
export const ORG_CHART_NEXT_STEP = "ORG_CHART_NEXT_STEP";
export const ORG_CHART_PREVIOUS_STEP = "ORG_CHART_PREVIOUS_STEP";
export const ORG_CHART_STORE_ALL_COLUMNS_AND_DATA =
  "ORG_CHART_STORE_ALL_COLUMNS_AND_DATA";
export const ORG_CHART_STORE_MATCHED_COLUMN = "ORG_CHART_STORE_MATCHED_COLUMN";
export const ORG_CHART_SELF_OFFICE_SELECTED = "ORG_CHART_SELF_OFFICE_SELECTED";
export const ORG_CHART_STORE_ALL_OFFICES = "ORG_CHART_STORE_ALL_OFFICES";
export const ORG_CHART_STORE_OFFICE_HIERARCHY =
  "ORG_CHART_STORE_OFFICE_HIERARCHY";

export const MANAGE_NEW_OFFICES = "MANAGE_NEW_OFFICES";
export const SAVE_HIERARCHY_CHANGES = "SAVE_HIERARCHY_CHANGES";
export const SAVE_NEW_HIERARCHY = "SAVE_NEW_HIERARCHY";
export const SAVE_UPDATED_OFFICES = "SAVE_UPDATED_OFFICES";
export const SAVE_DISABLED_OFFICES = "SAVE_DISABLED_OFFICES";

export const ORG_CHART_STORE_MATERIAL_PATHS = "ORG_CHART_STORE_MATERIAL_PATHS";
export const ORG_CHART_FLAGGED_ADMIN_OFFICE_SELECTED =
  "ORG_CHART_FLAGGED_ADMIN_OFFICE_SELECTED";
export const ORG_CHART_STORE_MATERIAL_PATHS_WITH_INVITATION =
  "ORG_CHART_STORE_MATERIAL_PATHS_WITH_INVITATION";
// export const ORG_CHART_SEARCH_OFFICE = "ORG_CHART_SEARCH_OFFICE";

//Map Gender
export const MAP_GENDER_UPLOAD_FILE_SUCCESS = "MAP_GENDER_UPLOAD_FILE_SUCCESS";
export const MAP_GENDER_MATCH_COLUMN_SUCCESS =
  "MAP_GENDER_MATCH_COLUMN_SUCCESS";
export const MAP_GENDER_NEXT_STEP = "MAP_GENDER_NEXT_STEP";
export const MAP_GENDER_PREVIOUS_STEP = "MAP_GENDER_PREVIOUS_STEP";
export const MAP_GENDER_SAVE_GENDER_MAPPING = "MAP_GENDER_SAVE_GENDER_MAPPING";
export const MAP_GENDER_RESET = "MAP_GENDER_RESET";
export const MAP_GENDER_RESET_STEP = "MAP_GENDER_RESET_STEP";

//Map Positions
export const MAP_POSITIONS_UPLOAD_FILE_SUCCESS =
  "MAP_POSITIONS_UPLOAD_FILE_SUCCESS";
export const MAP_POSITIONS_MATCH_COLUMN_SUCCESS =
  "MAP_POSITIONS_MATCH_COLUMN_SUCCESS";
export const MAP_POSITIONS_NEXT_STEP = "MAP_POSITIONS_NEXT_STEP";
export const MAP_POSITIONS_PREVIOUS_STEP = "MAP_POSITIONS_PREVIOUS_STEP";
export const MAP_POSITIONS_SAVE_POSITIONS_MAPPING =
  "MAP_POSITIONS_SAVE_POSITIONS_MAPPING";
export const MAP_POSITIONS_RESET = "MAP_POSITIONS_RESET";
export const MAP_POSITIONS_RESET_STEP = "MAP_POSITIONS_RESET_STEP";

//Map Performance
export const MAP_PERFORMANCE_UPLOAD_FILE_SUCCESS =
  "MAP_PERFORMANCE_UPLOAD_FILE_SUCCESS";
export const MAP_PERFORMANCE_MATCH_COLUMN_SUCCESS =
  "MAP_PERFORMANCE_MATCH_COLUMN_SUCCESS";
export const MAP_PERFORMANCE_NEXT_STEP = "MAP_PERFORMANCE_NEXT_STEP";
export const MAP_PERFORMANCE_PREVIOUS_STEP = "MAP_PERFORMANCE_PREVIOUS_STEP";
export const MAP_PERFORMANCE_SAVE_PERFORMANCE_MAPPING =
  "MAP_PERFORMANCE_SAVE_PERFORMANCE_MAPPING";
export const MAP_PERFORMANCE_RESET = "MAP_PERFORMANCE_RESET";
export const MAP_PERFORMANCE_RESET_STEP = "MAP_PERFORMANCE_RESET_STEP";

//Map Veterans Fields
export const MAP_VETERAN_UPLOAD_FILE_SUCCESS =
  "MAP_VETERAN_UPLOAD_FILE_SUCCESS";
export const MAP_VETERAN_MATCH_COLUMN_SUCCESS =
  "MAP_VETERAN_MATCH_COLUMN_SUCCESS";
export const MAP_VETERAN_NEXT_STEP = "MAP_VETERAN_NEXT_STEP";
export const MAP_VETERAN_PREVIOUS_STEP = "MAP_VETERAN_PREVIOUS_STEP";
export const MAP_VETERAN_SAVE_VETERAN_MAPPING =
  "MAP_VETERAN_SAVE_VETERAN_MAPPING";
export const MAP_VETERAN_RESET = "MAP_VETERAN_RESET";
export const MAP_VETERAN_RESET_STEP = "MAP_VETERAN_RESET_STEP";

//Nav Bar Header
export const NAVBAR_UPDATE = "NAVBAR_UPDATE";
export const NAVBAR_RESET = "NAVBAR_RESET";

//Map Disability Fields
export const MAP_DISABILITY_UPLOAD_FILE_SUCCESS =
  "MAP_DISABILITY_UPLOAD_FILE_SUCCESS";
export const MAP_DISABILITY_MATCH_COLUMN_SUCCESS =
  "MAP_DISABILITY_MATCH_COLUMN_SUCCESS";
export const MAP_DISABILITY_NEXT_STEP = "MAP_DISABILITY_NEXT_STEP";
export const MAP_DISABILITY_PREVIOUS_STEP = "MAP_DISABILITY_PREVIOUS_STEP";
export const MAP_DISABILITY_SAVE_DISABILITY_MAPPING =
  "MAP_DISABILITY_SAVE_DISABILITY_MAPPING";
export const MAP_DISABILITY_RESET = "MAP_DISABILITY_RESET";
export const MAP_DISABILITY_RESET_STEP = "MAP_DISABILITY_RESET_STEP";

//Map Sexual Orientation Fields
export const MAP_SEXUAL_ORIENTATION_UPLOAD_FILE_SUCCESS =
  "MAP_SEXUAL_ORIENTATION_UPLOAD_FILE_SUCCESS";
export const MAP_SEXUAL_ORIENTATION_MATCH_COLUMN_SUCCESS =
  "MAP_SEXUAL_ORIENTATION_MATCH_COLUMN_SUCCESS";
export const MAP_SEXUAL_ORIENTATION_NEXT_STEP =
  "MAP_SEXUAL_ORIENTATION_NEXT_STEP";
export const MAP_SEXUAL_ORIENTATION_PREVIOUS_STEP =
  "MAP_SEXUAL_ORIENTATION_PREVIOUS_STEP";
export const MAP_SEXUAL_ORIENTATION_SAVE_SEXUAL_ORIENTATION_MAPPING =
  "MAP_SEXUAL_ORIENTATION_SAVE_SEXUAL_ORIENTATION_MAPPING";
export const MAP_SEXUAL_ORIENTATION_RESET = "MAP_SEXUAL_ORIENTATION_RESET";
export const MAP_SEXUAL_ORIENTATION_RESET_STEP =
  "MAP_SEXUAL_ORIENTATION_RESET_STEP";

//Map Religion Fields
export const MAP_RELIGION_UPLOAD_FILE_SUCCESS =
  "MAP_RELIGION_UPLOAD_FILE_SUCCESS";
export const MAP_RELIGION_MATCH_COLUMN_SUCCESS =
  "MAP_RELIGION_MATCH_COLUMN_SUCCESS";
export const MAP_RELIGION_NEXT_STEP = "MAP_RELIGION_NEXT_STEP";
export const MAP_RELIGION_PREVIOUS_STEP = "MAP_RELIGION_PREVIOUS_STEP";
export const MAP_RELIGION_SAVE_RELIGION_MAPPING =
  "MAP_RELIGION_SAVE_RELIGION_MAPPING";
export const MAP_RELIGION_RESET = "MAP_RELIGION_RESET";
export const MAP_RELIGION_RESET_STEP = "MAP_RELIGION_RESET_STEP";

//Map Ethnicity
export const MAP_ETHNICITY_UPLOAD_FILE_SUCCESS =
  "MAP_ETHNICITY_UPLOAD_FILE_SUCCESS";
export const MAP_ETHNICITY_MATCH_COLUMN_SUCCESS =
  "MAP_ETHNICITY_MATCH_COLUMN_SUCCESS";
export const MAP_ETHNICITY_NEXT_STEP = "MAP_ETHNICITY_NEXT_STEP";
export const MAP_ETHNICITY_PREVIOUS_STEP = "MAP_ETHNICITY_PREVIOUS_STEP";
export const MAP_ETHNICITY_SAVE_ETHNICITY_MAPPING =
  "MAP_ETHNICITY_SAVE_ETHNICITY_MAPPING";
export const MAP_ETHNICITY_RESET = "MAP_ETHNICITY_RESET";
export const MAP_ETHNICITY_RESET_STEP = "MAP_ETHNICITY_RESET_STEP";

//Map Separation
export const MAP_SEPARATION_UPLOAD_FILE_SUCCESS =
  "MAP_SEPARATION_UPLOAD_FILE_SUCCESS";
export const MAP_SEPARATION_MATCH_COLUMN_SUCCESS =
  "MAP_SEPARATION_MATCH_COLUMN_SUCCESS";
export const MAP_SEPARATION_NEXT_STEP = "MAP_SEPARATION_NEXT_STEP";
export const MAP_SEPARATION_PREVIOUS_STEP = "MAP_SEPARATION_PREVIOUS_STEP";
export const MAP_SEPARATION_SAVE_SEPARATION_MAPPING =
  "MAP_SEPARATION_SAVE_SEPARATION_MAPPING";
export const MAP_SEPARATION_RESET = "MAP_SEPARATION_RESET";
export const MAP_SEPARATION_RESET_STEP = "MAP_SEPARATION_RESET_STEP";

//KPI master
export const STORE_KPI_MASTER_LIST = "STORE_KPI_MASTER_LIST";
export const STORE_MAPPING_MASTER_LIST = "STORE_MAPPING_MASTER_LIST";

// Enterprise Objectives
export const STORE_ENTERPRISE_OBJECTIVES = "STORE_ENTERPRISE_OBJECTIVES";
export const GET_ENTERPRISEOBJECTIVE_ASSOCIATED_ACTIONS =
  "GET_ENTERPRISEOBJECTIVE_ASSOCIATED_ACTIONS";
export const RESET_OBJECTIVES = "RESET_OBJECTIVES";
export const RESET_OBJECTIVE_ACTIONS = "RESET_OBJECTIVE_ACTIONS";

//Admin
export const STORE_USERS_ANALYTICS_DATA = "STORE_USERS_ANALYTICS_DATA";
export const STORE_TOOLKIT_ANALYTICS_DATA = "STORE_TOOLKIT_ANALYTICS_DATA";
export const STORE_CHART_ANALYTICS_DATA = "STORE_CHART_ANALYTICS_DATA";
export const FETCH_USERS_METRICES_LIST = "FETCH_USERS_METRICES_LIST";
export const FETCH_TOOLKIT_MATRICS_LIST = "FETCH_TOOLKIT_MATRICS_LIST";
export const FETCH_CHART_MATRICS_LIST = "FETCH_CHART_MATRICS_LIST";
export const STORE_ACTIONS_ANALYTICS_DATA = "STORE_ACTIONS_ANALYTICS_DATA";
export const FETCH_ACTIONS_METRICES_LIST = "FETCH_ACTIONS_METRICES_LIST";
export const STORE_STORIES_ANALYTICS_DATA = "STORE_STORIES_ANALYTICS_DATA";
export const FETCH_STORIES_MATRICES_LIST = "FETCH_STORIES_MATRICES_LIST";

// Dashboard
export const UPDATE_REPORT = "UPDATE_REPORT";
export const ADD_REPORT_CHARTS = "ADD_REPORT_CHARTS";
export const UPDATE_REPORT_CHARTS = "UPDATE_REPORT_CHARTS";
export const CREATE_DASHBOARD_REPORT = "CREATE_DASHBOARD_REPORT";

//Sort filter
export const UPDATE_ACTION_SORT = "UPDATE_ACTION_SORT";
export const UPDATE_ACTION_FILTER = "UPDATE_ACTION_FILTER";

export const UPDATE_OBJECTIVE_SORT = "UPDATE_OBJECTIVE_SORT";
export const UPDATE_OBJECTIVE_FILTER = "UPDATE_OBJECTIVE_FILTER";
export const ADD_DANI_ASSISTANT_SESSION_MESSAGES =
  "ADD_DANI_ASSISTANT_SESSION_MESSAGES";
export const UPDATE_DANI_ASSISTANT_SESSION_MESSAGES =
  "UPDATE_DANI_ASSISTANT_SESSION_MESSAGES";
export const DANI_CLEAR_STEPS = "DANI_CLEAR_STEPS";
export const DANI_UPDATE_STEP = "DANI_UPDATE_STEP";
export const FETCH_RESULTS_LOADING = "FETCH_RESULTS_LOADING";
export const ADD_CHATS_TO_HISTORY = "ADD_CHATS_TO_HISTORY";
export const SET_LATEST_STEP_ID = "SET_LATEST_STEP_ID";
export const SET_DANI_CURRENT_CHAT_ID = "SET_DANI_CURRENT_CHAT_ID";
export const SET_DANI_EXTRACTED_TEXT = "SET_DANI_EXTRACTED_TEXT";
export const DELETE_DANI_HISTORY_CHAT = "DELETE_DANI_HISTORY_CHAT";
export const DANI_SET_FILE_MULTIPART_RESPONSE =
  "DANI_SET_FILE_MULTIPART_RESPONSE";
export const DANI_RESET_FILE_MULTIPART_RESPONSE =
  "DANI_RESET_FILE_MULTIPART_RESPONSE";
export const UPDATE_TRIVIA_RESPOSNES = "UPDATE_TRIVIA_RESPOSNES";
export const SET_CURRENT_QUESTION = "SET_CURRENT_QUESTION";
export const SET_CURRENT_QUIZ_QUESTION = "SET_CURRENT_QUIZ_QUESTION";
export const SET_ANSWER_TYPE = "SET_ANSWER_TYPE";
export const COMPLETE_TRIVIA = "COMPLETE_TRIVIA";
export const RESET_TRIVIA = "RESET_TRIVIA";
export const SET_CURRENT_TRIVIA = "SET_CURRENT_TRIVIA";
export const EDIT_CURRENT_TRIVIA_QUESTIONS = "EDIT_CURRENT_TRIVIA_QUESTIONS";
export const EDIT_CURRENT_TRIVIA_WELCOME_DATA =
  "EDIT_CURRENT_TRIVIA_WELCOME_DATA";
export const EDIT_CURRENT_TRIVIA_ENDING_DATA =
  "EDIT_CURRENT_TRIVIA_ENDING_DATA";
export const EDIT_CURRENT_TRIVIA_THEME_DATA = "EDIT_CURRENT_TRIVIA_THEME_DATA";
export const EDIT_CURRENT_TRIVIA_SHARE_DATA = "EDIT_CURRENT_TRIVIA_SHARE_DATA";
export const UPDATE_TRIVIA_SORT = "UPDATE_TRIVIA_SORT";
export const UPDATE_MESSAGES_SORT = "UPDATE_MESSAGES_SORT";
export const UPDATE_TRIVIA_RESULT_SORT = "UPDATE_TRIVIA_RESULT_SORT";
export const UPDATE_MY_TRIVIA_SORT = "UPDATE_MY_TRIVIA_SORT";
export const SET_CURRENT_QUIZ = "SET_CURRENT_QUIZ";
export const SET_CURRENT_QUIZ_EXTERNAL_USER_DATA =
  "SET_CURRENT_QUIZ_EXTERNAL_USER_DATA";
export const SET_CURRENT_QUIZ_RESULT_OBJECT_ID =
  "SET_CURRENT_QUIZ_RESULT_OBJECT_ID";
export const SET_CURRENT_QUIZ_LINKED_REWARDS =
  "SET_CURRENT_QUIZ_LINKED_REWARDS";
export const SET_CURRENT_QUIZ_RESPONSES = "SET_CURRENT_QUIZ_RESPONSES";
export const SET_TRIVIA_RESULT_TABLE_COLS_MAP =
  "SET_TRIVIA_RESULT_TABLE_COLS_MAP";
export const SET_IMPORT_TEMPLATE_TRIVVYS = "SET_IMPORT_TEMPLATE_TRIVVYS";
export const SET_TRIVIA_BREAKING_NEWS = "SET_TRIVIA_BREAKING_NEWS";

export const SET_TRIVVY_RATING_SUBMITTED = "SET_TRIVVY_RATING_SUBMITTED";
export const UPDATE_LIBRARY_SORT = "UPDATE_LIBRARY_SORT";
export const UPDATE_LIBRARY_QUESTIONS_SORT = "UPDATE_LIBRARY_QUESTIONS_SORT";
export const OPEN_REAWRD_MODAL_GLOB = "OPEN_REAWRD_MODAL_GLOB";
export const UPDATE_SINGLE_LIB_STATS_TRIVVY_COUNT =
  "UPDATE_SINGLE_LIB_STATS_TRIVVYCOUNT";
export const UPDATE_SINGLE_LIB_STATS_QUESTION_COUNT =
  "UPDATE_SINGLE_LIB_STATS_QUESTION_COUNT";

export const SET_CURRENT_TRIVVY_COMMENTS = "SET_CURRENT_TRIVVY_COMMENTS";
export const SET_CREATE_MODAL_STATE = "SET_CREATE_MODAL_STATE";
export const SET_LIBRARY_SCHEDULE_LOADER = "SET_LIBRARY_SCHEDULE_LOADER";
export const UPDATE_GROUP_METRICS_SORT = "UPDATE_GROUP_METRICS_SORT";
export const UPDATE_GROUP_METRICS_FILTER = "UPDATE_GROUP_METRICS_FILTER";
export const DANI_SET_ENGAGE_ACTION_CLICK = "DANI_SET_ENGAGE_ACTION_CLICK";
export const USER_SET_SLACK_TEAMS_AFTERAUTH_RETURN_URL =
  "USER_SET_SLACK_TEAMS_AFTERAUTH_RETURN_URL";
export const SET_AFTER_LOGIN_REDIRECT = "SET_AFTER_LOGIN_REDIRECT";
export const SET_TRIVVY_CREATE_LOADER = "SET_TRIVVY_CREATE_LOADER";
export const SET_LIBRARY_CREATE_LOADER = "SET_LIBRARY_CREATE_LOADER";
export const SET_SUMMARY_GENERATE_LOADER = "SET_SUMMARY_GENERATE_LOADER";

export const UPDATE_SELECTED_DATE = "UPDATE_SELECTED_DATE";
export const UPDATE_EXTERNAL_USER_LOGIN = "UPDATE_EXTERNAL_USER_LOGIN";
export const SET_TRIVIA_POPULAR_IMAGES = "SET_TRIVIA_POPULAR_IMAGES";
export const SET_TRIVIA_POPULAR_VIDEOS = "SET_TRIVIA_POPULAR_VIDEOS";
export const SET_TRIVIA_POPULAR_GIFS = "SET_TRIVIA_POPULAR_GIFS";
